export default "__VITE_ASSET__DvmAtdKO__";